export default __webpack_public_path__ + "static/Immersive-experience-d35eaf3c1131f98c562a0b857fc8ff27.webp";